import { Box, getColor, Icons, Typography } from "fds";
import "./index.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import useAdminHomeStore from "../../redux/dispatcher/useAdminHomeStore";
import { CountRespondDto, DiskspaceRespondDto } from "../../types/adminHome";
import { EcoSystemLicenseStats } from "../../types/adminConfig";
import { getAdminInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";

const HomeTop = () => {
  const user = getAdminInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const {
    adminHomeStore,
    getDiskSpace,
    getCreatedWorkgroupCnt,
    getSharedDocCnt,
    getPageLicense,
    getMemberCnt,
  } = useAdminHomeStore();

  const [diskSpaceState, setDiskSpaceState] = useState(
    {} as DiskspaceRespondDto
  );
  const [createWorkgroupCnt, setCreateWorkgroupCnt] = useState(
    {} as CountRespondDto
  );
  const [sharedDocCnt, setsharedDocCnt] = useState({} as CountRespondDto);
  const [pageLicnse, setPageLicense] = useState({} as EcoSystemLicenseStats);
  const [memberCnt, setMemberCnt] = useState({} as CountRespondDto);
  const { t } = useTranslation();

  useEffect(() => {
    getDiskSpace();
    getCreatedWorkgroupCnt();
    getSharedDocCnt();
    getPageLicense();
    getMemberCnt();
  }, []);

  useEffect(() => {
    setDiskSpaceState(adminHomeStore.diskspace);
    setCreateWorkgroupCnt(adminHomeStore.createdWorkgroup);
    setsharedDocCnt(adminHomeStore.sharedDoc);
    setPageLicense(adminHomeStore.license);
    setMemberCnt(adminHomeStore.member);
  }, [adminHomeStore]);

  return (
    <Box alignItems="center" classes="adminHome_top">
      <Box
        justifyContent="center"
        direction="column"
        alignItems="center"
        classes="adminHome_top--box"
      >
        <Typography exactColor={getColor("COLOR_TEXT_SECONDARY")}>
          {t("admin.home.fileUsage")}
        </Typography>
        <CircularProgressbarWithChildren
          value={diskSpaceState.usageRate}
          strokeWidth={20}
          className={"mg mt-8"}
          styles={{
            root: { height: "120px" },
            path: {
              stroke: getColor("COLOR_ICON_BRAND"),
              strokeWidth: "8px",
              strokeLinecap: "butt",
              transition: "stroke-dashoffset 0.5s ease 0s",
            },

            trail: {
              stroke: "#d7d7d7",
              strokeWidth: "8px",
            },
            text: {
              fill: "#333333",
              fontSize: "18px",
            },
            background: {
              fill: "#3e98c7",
            },
          }}
        >
          <Box
            alignItems="center"
            direction="column"
            justifyContent="center"
            height={"120px"}
            style={{ marginTop: "-16px" }}
          >
            <Typography type="subtitle1">
              {Math.round(diskSpaceState.usageSize * 10) / 10}GB
            </Typography>
            <Typography
              type="body3_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {diskSpaceState.totalSize === 0
                ? t("admin.common.unlimited")
                : Math.round(diskSpaceState.totalSize)}
              {diskSpaceState.totalSize === 0 ? "" : "GB"}
            </Typography>
          </Box>
        </CircularProgressbarWithChildren>
      </Box>
      {loginDto?.ecoSystemLicenseStats?.featureAccessType !== "LITE" && (
        <Box
          justifyContent="center"
          direction="column"
          alignItems="center"
          classes="adminHome_top--box"
        >
          <Typography exactColor={getColor("COLOR_TEXT_SECONDARY")}>
            {t("admin.home.newWorkGroup")}
          </Typography>
          <Box classes="adminHome_top--icon">
            <Icons
              variant="line"
              label="document"
              stroke={getColor("COLOR_ICON_BRAND")}
            />
          </Box>
          <Box direction="row" classes="adminHome_top--rowBox">
            <Box direction="column" alignItems="center">
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.home.today")}
              </Typography>
              <Typography type="subtitle1">
                {createWorkgroupCnt.today}
              </Typography>
            </Box>
            <Box classes="adminHome_top--columnDivider" />
            <Box direction="column" alignItems="center">
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.home.overall")}
              </Typography>
              <Typography type="subtitle1">
                {createWorkgroupCnt.total}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
      <Box
        justifyContent="center"
        direction="column"
        alignItems="center"
        classes="adminHome_top--box"
      >
        <Typography exactColor={getColor("COLOR_TEXT_SECONDARY")}>
          {t("admin.home.sharedFile")}
        </Typography>
        <Box classes="adminHome_top--icon">
          <Icons
            variant="line"
            label="document"
            stroke={getColor("COLOR_ICON_BRAND")}
          />
        </Box>
        <Box direction="row" classes="adminHome_top--rowBox">
          <Box direction="column" alignItems="center">
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.today")}
            </Typography>
            <Typography type="subtitle1">{sharedDocCnt.today}</Typography>
          </Box>
          <Box classes="adminHome_top--columnDivider" />
          <Box direction="column" alignItems="center">
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.overall")}
            </Typography>
            <Typography type="subtitle1">{sharedDocCnt.total}</Typography>
          </Box>
        </Box>
      </Box>
      <Box
        justifyContent="center"
        direction="column"
        alignItems="center"
        classes="adminHome_top--box"
      >
        <Typography
          fontSize={14}
          lineHeight={"14px"}
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
        >
          {t("admin.home.userStatus")}
        </Typography>
        <Box direction="column" classes="adminHome_top--body mg mt-24">
          <Box direction="row" width={"100%"} alignItems="center">
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.using")}
            </Typography>
            <Typography
              type="subtitle1"
              classes="mg ml-auto"
              exactColor={getColor("COLOR_ICON_BRAND")}
            >
              {pageLicnse.usedInternalCount}
            </Typography>
          </Box>
          <Box
            direction="row"
            width={"100%"}
            alignItems="center"
            classes="mg mt-16"
          >
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.remainLicense")}
            </Typography>
            <Typography type="subtitle1" classes="mg ml-auto">
              {pageLicnse.internalLicenseCount - pageLicnse.usedInternalCount}
            </Typography>
          </Box>
          <div className="adminHome_top--rowDivider mg mt-16" />
          <Box
            direction="row"
            width={"100%"}
            alignItems="center"
            classes="mg mt-16"
          >
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.totalLicense")}
            </Typography>
            <Typography type="subtitle1" classes="mg ml-auto">
              {pageLicnse.internalLicenseCount}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        justifyContent="center"
        direction="column"
        alignItems="center"
        classes="adminHome_top--box"
      >
        <Typography
          fontSize={14}
          lineHeight={"14px"}
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
        >
          {t("admin.home.externalUserStatus")}
        </Typography>
        <Box direction="column" classes="adminHome_top--body mg mt-24">
          <Box direction="row" width={"100%"} alignItems="center">
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.usingLogin")}
            </Typography>
            <Typography
              type="subtitle1"
              classes="mg ml-auto"
              exactColor={getColor("COLOR_ICON_BRAND")}
            >
              {pageLicnse.usedExternalCount}
            </Typography>
          </Box>
          <Box
            direction="row"
            width={"100%"}
            alignItems="center"
            classes="mg mt-16"
          >
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.remainLicense")}
            </Typography>
            <Typography type="subtitle1" classes="mg ml-auto">
              {pageLicnse.externalLicenseCount - pageLicnse.usedExternalCount}
            </Typography>
          </Box>
          <div className="adminHome_top--rowDivider mg mt-16" />
          <Box
            direction="row"
            width={"100%"}
            alignItems="center"
            classes="mg mt-16"
          >
            <Typography
              type="body2_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("admin.home.totalLicense")}
            </Typography>
            <Typography type="subtitle1" classes="mg ml-auto">
              {pageLicnse.externalLicenseCount}
            </Typography>
          </Box>
        </Box>
      </Box>
      {pageLicnse.liteExternalLicenseCount > 0 && (
        <Box
          justifyContent="center"
          direction="column"
          alignItems="center"
          classes="adminHome_top--box"
        >
          <Typography
            fontSize={14}
            lineHeight={"14px"}
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("admin.home.otpUserStatus")}
          </Typography>
          <Box direction="column" classes="adminHome_top--body mg mt-24">
            <Box direction="row" width={"100%"} alignItems="center">
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.home.using")}
              </Typography>
              <Typography
                type="subtitle1"
                classes="mg ml-auto"
                exactColor={getColor("COLOR_ICON_BRAND")}
              >
                {pageLicnse.usedLiteExternalCount}
              </Typography>
            </Box>
            <Box
              direction="row"
              width={"100%"}
              alignItems="center"
              classes="mg mt-16"
            >
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.home.remainLicense")}
              </Typography>
              <Typography type="subtitle1" classes="mg ml-auto">
                {pageLicnse.liteExternalLicenseCount -
                  pageLicnse.usedLiteExternalCount}
              </Typography>
            </Box>
            <div className="adminHome_top--rowDivider mg mt-16" />
            <Box
              direction="row"
              width={"100%"}
              alignItems="center"
              classes="mg mt-16"
            >
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                {t("admin.home.totalLicense")}
              </Typography>
              <Typography type="subtitle1" classes="mg ml-auto">
                {pageLicnse.liteExternalLicenseCount}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export default HomeTop;
